import { render, staticRenderFns } from "./bare.vue?vue&type=template&id=0fd6016a&"
import script from "./bare.vue?vue&type=script&lang=js&"
export * from "./bare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports